export class Topic {
    topic_id: number = -1;
    topic_name: string = "";
    topic_type: string = "";
    topic_icon: string = "";
    private topicIsSelected: boolean = false;
    constructor(topic_id?:number, name?:string, type?:string, is_selected?:boolean, icon?:string){
        if(name != null){
            this.topic_name = name;
        }
        if(type != null){
            this.topic_type = type;
        }

        if(topic_id != null){
            this.topic_id = topic_id;
        }
        if(is_selected!=null){
           this.topicIsSelected=is_selected;
        }
        if(icon!=null){
            this.topic_icon=icon;
        }
    }
    public selectTopic(){
        this.topicIsSelected = true;
    }

    public unselectTopic(){
        this.topicIsSelected = false;
    }

    public isSelected():boolean{
        return this.topicIsSelected;
    }

    public toggleSelection():void{
        this.topicIsSelected = !(this.topicIsSelected);
    }
}

export class Topics {
    private list: Topic[] = [];
    constructor(listOfTopics?:Topic[]){
        if(listOfTopics != null){
            this.list=listOfTopics;
        }
    }
    getTopics():Topic[]{
        return this.list;
    }
    addTopic(topicToAdd:Topic):boolean{
        let topicsWithMatchingTopicId=0;
        for(let ele of this.list){
            if(ele.topic_id == topicToAdd.topic_id){
                topicsWithMatchingTopicId++;
            }
        }
        if(topicsWithMatchingTopicId == 0){
            this.list.push(topicToAdd);
            return true;
        }
        return false;
    }
    removeTopic(topicToRemove:Topic):boolean{
        let topicsWithMatchingTopicId=0;
        for(let index in this.list){
            if(this.list[index].topic_id == topicToRemove.topic_id){
                topicsWithMatchingTopicId++;
                delete this.list[index];
            }
        }
        if(topicsWithMatchingTopicId != 0){
            return true;
        }
        return false;
    }
}

export class TopicforUser {
    topic_id: number = -1;
    topic_name: string = "default_topic_name";
    topic_enabled: boolean = false;
    topic_type: "default_topic_type";
    parent_topic_id: "parent_topic_id";
}
